import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Col, Button, Drawer } from "antd";
import CustomList from "../../../../components/List";
import ListItem from "../../../../components/ListItem";
import CustomPagination from "../../../../components/CustomPagination";
import { useGrievances } from "../../../../../hooks/useDataHooks";
import { useReportDateRange } from "../../../../../hooks/useReportDateRange";
import useProcuringEntityPackage from "../../../../../hooks/useProcuringEntityPackage";
import ActionBar from "../../../../components/ActionBar";

const Sub_project_name = { xxl: 4, xl: 4, lg: 4, md: 4, sm: 12, xs: 12 };
const TotalGrievances = { xxl: 4, xl: 4, lg: 4, md: 4, sm: 12, xs: 12 };
const Resolved = { xxl: 3, xl: 3, lg: 3, md: 3, sm: 12, xs: 12 };
const InProgress = { xxl: 3, xl: 3, lg: 3, md: 3, sm: 0, xs: 0 };
const Pending = { xxl: 3, xl: 3, lg: 3, md: 3, sm: 0, xs: 0 };
const Categories = { xxl: 4, xl: 4, lg: 4, md: 4, sm: 0, xs: 0 };

const Grievances = ({ match }) => {
  const {
    params: { packageId },
  } = match;
  const { startDate, endDate } = useReportDateRange();
  console.log("GrievancesDATE:", startDate);
  console.log("GrievancesDATE:", endDate);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { grievances, pagination, loading } = useGrievances(packageId, currentPage, pageSize);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [activeItem, setActiveItem] = useState(null);

  const history = useHistory();
  const { procuringEntityPackage } = useProcuringEntityPackage(packageId);
  const packageName = procuringEntityPackage?.name || "";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    if (size !== pageSize) {
      setPageSize(size);
    }
  };

  const openDrawer = (item) => {
    setActiveItem(item);
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
    setActiveItem(null);
  };

  return (
    <>
      <div style={{ width: "100%", padding: "24px" }}>
        <ActionBar actionButtonProp={{
          title: `${packageName || "==//=="}: Grievances Information`,
        }} />

        <div className="prst-table">
          <CustomList
            itemName={`Grievances`}
            items={grievances}
            page={currentPage}
            itemCount={pagination?.total || grievances?.length}
            loading={loading}
            headerLayout={[
              { ...Sub_project_name, header: "Sub-project" },
              { ...TotalGrievances, header: "Total No. of Grievances" },
              { ...Resolved, header: "Resolved" },
              { ...InProgress, header: "In Progress" },
              { ...Pending, header: "Pending" },
              { ...Categories, header: "Categories" },
            ]}
            renderListItem={({ item }) => (
              <ListItem
                key={item.package_number}
                name={item?.Sub_project_name || "==//=="}
                item={item}
                isPackage={false}
                renderActions={() => false}
                onClick={() => openDrawer(item)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "8px",
                  borderBottom: "1px solid #e8e8e8",
                  backgroundColor: activeItem === item ? "#e6f7ff" : "white",
                }}
              >
                <Col
                  {...Sub_project_name}
                  className="contentEllipse"
                  title={item.Sub_project_name || "==//=="}
                  data-label="Sub-project"
                >
                  {item.Sub_project_name || "--//--"}
                </Col>
                <Col
                  {...TotalGrievances}
                  className="contentEllipse"
                  title={item.GrievanceReceived || "==//=="}
                  data-label="Total Grievances"
                >
                  {item.GrievanceReceived || "==//=="}
                </Col>
                <Col
                  {...Resolved}
                  className="contentEllipse"
                  title={item.resolved || "==//=="}
                  data-label="Resolved"
                >
                  {item.resolved || "==//=="}
                </Col>
                <Col
                  {...InProgress}
                  className="contentEllipse"
                  title={item.in_progress || "==//=="}
                  data-label="In Progress"
                >
                  {item.in_progress || "==//=="}
                </Col>
                <Col
                  {...Pending}
                  className="contentEllipse"
                  title={item.pending || "==//=="}
                  data-label="Pending"
                >
                  {item.pending || "==//=="}
                </Col>
                <Col
                  {...Categories}
                  className="contentEllipse"
                  title={item.GrievanceCategory || "==//=="}
                  data-label="Categories"
                >
                  {item.GrievanceCategory || "==//=="}
                </Col>
                
                <div className="view-card-details" onClick={() => openDrawer(item)}>
                  View Details
                </div>
              </ListItem>
            )}
          />
        </div>

        {pagination && (
          <CustomPagination
            pagination={pagination}
            onPageChange={handlePageChange}
            loading={loading}
          />
        )}
      </div>

      <Drawer
        title="Grievance Details"
        placement="right"
        closable={true}
        onClose={closeDrawer}
        visible={drawerVisible}
        width={720}
      >
        {activeItem && (
          <div>
            <p>
              <strong>Sub-project:</strong>{" "}
              {activeItem?.Sub_project_name || "==//=="}
            </p>
            <p>
              <strong>Description:</strong>{" "}
              {activeItem?.GrievanceDescription || "==//=="}
            </p>
            <p>
              <strong>Total No. of Grievances:</strong>{" "}
              {activeItem?.GrievanceReceived}
            </p>
            <p>
              <strong>Resolved:</strong> {activeItem?.resolved}
            </p>
            <p>
              <strong>Supporting Document:</strong>
              {activeItem?.resolved_document_url ? (
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    marginLeft: "10px",
                  }}
                >
                  <Button
                    className="styled-button"
                    onClick={() => {
                      if (activeItem?.resolved_document_url) {
                        window.open(
                          activeItem?.resolved_document_url,
                          "_blank"
                        );
                      }
                    }}
                  >
                    Download
                  </Button>
                </div>
              ) : (
                <span style={{ marginLeft: "10px" }}>-</span>
              )}
            </p>
            <p>
              <strong>In Progress:</strong> {activeItem?.in_progress}
            </p>
            <p>
              <strong>Pending:</strong> {activeItem?.pending}
            </p>
            <p>
              <strong>Categories:</strong>{" "}
              {activeItem?.grievance_category ? (
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {activeItem?.grievance_category.map((item) => (
                    <li
                      key={item.name}
                      style={{
                        display: "inline-block",
                        marginRight: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      <span
                        style={{
                          backgroundColor: "#f0f0f0",
                          padding: "5px 10px",
                          borderRadius: "10px",
                        }}
                      >
                        {item.name}{" "}
                        <span
                          style={{
                            marginLeft: "5px",
                            padding: "4px 8px",
                            borderRadius: "100%",
                            backgroundColor: "#D3D3D3",
                          }}
                        >
                          {item.count}
                        </span>{" "}
                      </span>
                    </li>
                  ))}
                </ul>
              ) : (
                "==//=="
              )}
            </p>
            <p>
              <strong>Summary of the Steps Taken:</strong>{" "}
              {activeItem?.Summary_of_the_Steps_Taken || "==//=="}
            </p>
            <p>
              <strong>Report Start Date:</strong>{" "}
              {activeItem?.report_start_date || "==//=="}
            </p>
            <p>
              <strong>Report End Date:</strong>{" "}
                {activeItem?.report_end_date || "==//=="}
            </p>
          </div>
        )}
      </Drawer>
    </>
  );
};

export default Grievances;
